export const checkInputValidity = (input) => {
  if (input.required && input.value === "") {
    input.classList.add("is-invalid");
    return true;
  }
  return false;
};

export const checkRadioGroup = (input) => {
  if (input.classList.contains("radio-group")) {
    const groupHasChecked = Array.from(
      document.getElementsByName(input.name)
    ).some((radio) => radio.checked);
    if (!groupHasChecked) {
      input.classList.add("is-invalid");
      return true;
    }
  }
  return false;
};

export const checkSelectGroup = (input) => {
  if (input.classList.contains("select-group")) {
    if (input.value === "") {
      input.classList.add("is-invalid");
      return true;
    }
    const hasValidSelect = Array.from(
      document.getElementsByName(input.name)
    ).some((select) => select.value !== "");
    if (!hasValidSelect) {
      input.classList.add("is-invalid");
      return true;
    }
  }
  return false;
};

export const checkRegexInputs = () => {
  let hasError = false;
  document.querySelectorAll(".inputReg").forEach((input) => {
    if (!input.checkValidity()) {
      input.classList.add("is-invalid");
      hasError = true;
    }
  });
  return hasError;
};

export const checkEmailConfirmation = (page, formData) => {
  let hasError = false;
  const emailConfirm = document.querySelector(".confirmMandataireEmail");
  const confirmMandantEmail_P = document.querySelector(
    ".confirmMandantEmail_P"
  );
  const confirmMandantEmail_M = document.querySelector(
    ".confirmMandantEmail_M"
  );

  if (page === 1) {
    if (
      formData.MandataireOuiNon === "Oui" &&
      emailConfirm.value !== formData.MandataireEmail
    ) {
      emailConfirm.classList.add("is-invalid");
      hasError = true;
    }
    if (
      confirmMandantEmail_P &&
      confirmMandantEmail_P.value !== formData.MandantEmail
    ) {
      confirmMandantEmail_P.classList.add("is-invalid");
      hasError = true;
    }
    if (
      confirmMandantEmail_M &&
      confirmMandantEmail_M.value !== formData.MandantEmail
    ) {
      confirmMandantEmail_M.classList.add("is-invalid");
      hasError = true;
    }
  }
  return hasError;
};